import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { ImpactDataService } from 'src/services'

import { QUERY_KEYS } from 'src/constants'

const useImpactScanToEarnInfo = () => {
  const { id } = useParams()

  return useQuery(
    [QUERY_KEYS.GET_IMPACT_SCAN_TO_EARN_INFO, id],
    async () => {
      return await ImpactDataService.getImpactScanToEarnInfoById(id)
    },
    {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: !!id,
    },
  )
}

export { useImpactScanToEarnInfo }
